import { TopNavigationBarContainer } from "containers/top-navigation-bar";
import { Outlet } from "react-router";
import { SideNavigationBarContainer } from "../../containers/side-navigation-bar";

const AppLayOut = () => {
  return (
    <div className="flex w-full h-screen overflow-hidden">
      <div
        className={`flex border-e border-[#E1DEDD] bg-white h-screen sticky top-0`}
      >
        <SideNavigationBarContainer />
      </div>
      <div className="flex flex-col flex-1 h-screen overflow-hidden">
        <div className="flex justify-center border-b border-[#E1DEDD] bg-white w-full py-[10px] flex-shrink-0">
          <TopNavigationBarContainer />
        </div>
        <div className="flex p-6 w-full flex-1 bg-[#FAF9F9] overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
export { AppLayOut };
